import { lazy } from 'react'

// PC 대시보드
export const SystemAdminDashboard = lazy(() => import('../../pages/dashboards/SystemAdminDashboard'))
export const MoldDeveloperDashboard = lazy(() => import('../../pages/dashboards/MoldDeveloperDashboard'))
export const MakerDashboard = lazy(() => import('../../pages/dashboards/MakerDashboard'))
export const PlantDashboard = lazy(() => import('../../pages/dashboards/PlantDashboard'))

// 모바일 대시보드 (PC Layout 내 사용)
export const MakerMobileDashboard = lazy(() => import('../../pages/dashboards/MakerMobileDashboard'))
export const PlantMobileDashboard = lazy(() => import('../../pages/dashboards/PlantMobileDashboard'))
export const DeveloperMobileDashboard = lazy(() => import('../../pages/dashboards/DeveloperMobileDashboard'))
// Phase D — SystemAdmin 역할별 모바일 대시보드 (SystemAdminDashboard PC 파리티)
export const SystemAdminMobileDashboard = lazy(() => import('../../pages/dashboards/SystemAdminMobileDashboard'))

// 관리자 전용
export const ApprovalInbox = lazy(() => import('../../pages/admin/ApprovalInbox'))
export const SystemRulesPage = lazy(() => import('../../pages/admin/SystemRulesPage'))
export const ApprovalKitAdminPage = lazy(() => import('../../approval-kit/admin/ApprovalKitAdminPage'))
export const ApprovalKitInboxPage = lazy(() => import('../../approval-kit/pages/ApprovalKitInboxPage'))
export const ApprovalRoute = lazy(() => import('../../approval-kit/ApprovalRoute'))
export const NotificationCenter = lazy(() => import('../../pages/admin/NotificationCenter'))
export const RiskMonitorDashboard = lazy(() => import('../../pages/admin/RiskMonitorDashboard'))
export const PartnerOperationsPage = lazy(() => import('../../pages/admin/PartnerOperationsPage'))
export const AuditLogPage = lazy(() => import('../../pages/admin/AuditLogPage'))

// 금형 관리
export const MoldList = lazy(() => import('../../pages/MoldList'))
// MoldDetail (레거시) 제거 — /molds/:id 는 MoldDetailNew 사용
export const MoldRegistration = lazy(() => import('../../pages/MoldRegistration'))
export const MoldNew = lazy(() => import('../../pages/MoldNew'))
export const MoldBulkUpload = lazy(() => import('../../pages/MoldBulkUpload'))
export const MoldMaster = lazy(() => import('../../pages/MoldMaster'))
export const MoldLifecycle = lazy(() => import('../../pages/MoldLifecycle'))
export const MoldDetailNew = lazy(() => import('../../pages/MoldDetailNew'))
export const MoldDocuments = lazy(() => import('../../pages/MoldDocuments'))
export const MoldPhotoGallery = lazy(() => import('../../pages/MoldPhotoGallery'))
export const MoldHistory = lazy(() => import('../../pages/MoldHistory'))
export const MoldQRCode = lazy(() => import('../../pages/MoldQRCode'))
// 2026-07-08 orphan 정리: 모바일 페어(MobileInspectionDueMoldList/MobileOverShotMoldList)는 라우팅 중이나 PC 배선 누락 → 복원
export const InspectionDueMoldListPage = lazy(() => import('../../pages/InspectionDueMoldListPage'))
export const OverShotMoldListPage = lazy(() => import('../../pages/OverShotMoldListPage'))

// 점검 관리
export const DailyChecklist = lazy(() => import('../../pages/DailyChecklistNew'))
export const PeriodicInspection = lazy(() => import('../../pages/PeriodicInspectionNew'))
export const InspectionApproval = lazy(() => import('../../pages/InspectionApproval'))
export const ChecklistMaster = lazy(() => import('../../pages/StandardDocumentMaster'))
export const MoldChecklist = lazy(() => import('../../pages/MoldChecklist'))

// 이관 관리
export const TransferManagement = lazy(() => import('../../pages/TransferManagement'))
export const TransferRequest = lazy(() => import('../../pages/TransferRequest'))

// 수리 관리
export const RepairManagement = lazy(() => import('../../pages/RepairManagement'))
export const RepairRequestForm = lazy(() => import('../../pages/RepairRequestForm'))
export const HqRepairListPage = lazy(() => import('../../pages/HqRepairListPage'))
export const MakerRepairListPage = lazy(() => import('../../pages/MakerRepairListPage'))
export const RepairShipmentChecklist = lazy(() => import('../../pages/RepairShipmentChecklist'))
export const MoldRepairHistory = lazy(() => import('../../pages/MoldRepairHistory'))
export const MoldTransferHistory = lazy(() => import('../../pages/MoldTransferHistory'))
// Phase BD: 점검 결과 이력관리
export const MoldInspectionHistory = lazy(() => import('../../pages/MoldInspectionHistory'))

// 제작처 전용
export const MakerMoldDetail = lazy(() => import('../../pages/maker/MakerMoldDetail'))

// 금형 개발
export const MoldDevelopmentPlan = lazy(() => import('../../pages/MoldDevelopmentPlan'))
export const MoldNurturingPage = lazy(() => import('../../pages/MoldNurturingPage'))
export const MoldNurturingOverview = lazy(() => import('../../pages/MoldNurturingOverview'))
export const HardnessMeasurement = lazy(() => import('../../pages/HardnessMeasurement'))
export const MoldSpecification = lazy(() => import('../../pages/MoldSpecification'))
// 투자비 관리 — 본사 대량 편집 그리드 (PC 전용)
export const MoldInvestment = lazy(() => import('../../pages/MoldInvestment'))
// M2 Task 7: 성형해석 검증 (molding-engine 수동입력 + 계산 결과)
export const MoldingAnalysis = lazy(() => import('../../pages/MoldingAnalysis'))

// 사출 관리
export const InjectionHistory = lazy(() => import('../../pages/InjectionHistory'))
export const InjectionStats = lazy(() => import('../../pages/InjectionStats'))
export const InjectionCondition = lazy(() => import('../../pages/InjectionCondition'))

// 회사/사용자 관리
export const CompanyManagement = lazy(() => import('../../pages/CompanyManagement'))
export const CompanyDetail = lazy(() => import('../../pages/CompanyDetail'))
export const CompanyProfile = lazy(() => import('../../pages/CompanyProfile'))
export const PartnerInjectionSummary = lazy(() => import('../../pages/PartnerInjectionSummary'))
export const PartnerEquipmentSummary = lazy(() => import('../../pages/PartnerEquipmentSummary'))
export const PartnerPaintLineSummary = lazy(() => import('../../pages/PartnerPaintLineSummary'))
export const PlantMoldSelect = lazy(() => import('../../pages/PlantMoldSelect'))
export const UserRequests = lazy(() => import('../../pages/UserRequests'))
export const InternalUsers = lazy(() => import('../../pages/InternalUsers'))
export const PartnerUsers = lazy(() => import('../../pages/PartnerUsers'))
export const MasterData = lazy(() => import('../../pages/MasterData'))
// 2026-11-02: 점검관리 마스터 (점검 가이드 템플릿) — PC 전용 관리자 화면
export const InspectionGuideMaster = lazy(() => import('../../pages/admin/InspectionGuideMaster'))

// 통합관리
export const MoldWorkflowManagement = lazy(() => import('../../pages/MoldWorkflowManagement'))

// 기타 관리
export const Alerts = lazy(() => import('../../pages/Alerts'))
export const AlertDetail = lazy(() => import('../../pages/AlertDetail'))
export const StandardDocumentMaster = lazy(() => import('../../pages/StandardDocumentMaster'))
export const ScrappingManagement = lazy(() => import('../../pages/ScrappingManagement'))
export const MoldScrappingProgress = lazy(() => import('../../pages/MoldScrappingProgress'))
export const MaintenanceManagement = lazy(() => import('../../pages/MaintenanceManagement'))
export const NotificationSettings = lazy(() => import('../../pages/NotificationSettings'))

// PC 전역 검색 (MobileSearch 파리티)
export const GlobalSearch = lazy(() => import('../../pages/GlobalSearch'))
// PC 초도T/O 이슈관리 (MobileTryoutIssue 파리티)
export const MoldTryoutIssue = lazy(() => import('../../pages/MoldTryoutIssue'))
// 운영 게시판 (2026-06-30)
export const Board = lazy(() => import('../../pages/Board'))
// Phase G-2: Task Center
export const TaskCenter = lazy(() => import('../../pages/TaskCenter'))
// Phase H-D: 메뉴/버튼 권한 관리
export const MenuPermissionsPage = lazy(() => import('../../pages/admin/MenuPermissionsPage'))
// 협력사 초기화 + 일괄 등록 (system_admin 1회 작업)
export const SeedCompaniesPage = lazy(() => import('../../pages/admin/SeedCompaniesPage'))
// 업체 통합(merge) — source 를 target 으로 흡수 + 다공장 전환
export const MergeCompaniesPage = lazy(() => import('../../pages/admin/MergeCompaniesPage'))
export const ImageCleanupPage = lazy(() => import('../../pages/admin/ImageCleanupPage'))
export const PasswordSecurityPage = lazy(() => import('../../pages/admin/PasswordSecurityPage'))
export const PartnerFinancePage = lazy(() => import('../../pages/admin/PartnerFinancePage'))
// 대여자산 실사 (SP-1) — PC 전용 이름. lazy/mobile.js 에 동일 이름 재export 금지 (허브 export * ambiguous 드롭)
export const AssetAuditPage = lazy(() => import('../../pages/admin/AssetAuditPage'))
export const AsMoldRegistryPage = lazy(() => import('../../pages/admin/AsMoldRegistryPage'))
export const AssetAuditDetailPage = lazy(() => import('../../pages/admin/AssetAuditDetailPage'))
// Phase FJ: 잘못 비활성화된 업체 일괄 재활성화
export const ReactivateCompaniesPage = lazy(() => import('../../pages/admin/ReactivateCompaniesPage'))
// 금형 초기화 (system_admin)
export const ResetMoldsPage = lazy(() => import('../../pages/admin/ResetMoldsPage'))
// Phase BM: 전체 금형 양산중 일괄 전환 (system_admin 1회 작업)
export const SetMoldsActivePage = lazy(() => import('../../pages/admin/SetMoldsActivePage'))
// Phase I-2: 승인 템플릿 관리
export const ApprovalTemplatesPage = lazy(() => import('../../pages/admin/ApprovalTemplatesPage'))
// Phase K: 승인 위임
export const DelegationsPage = lazy(() => import('../../pages/admin/DelegationsPage'))
// Phase 2.1: 통합 점검/유지보전
export const MaintenanceTasksUnified = lazy(() => import('../../pages/MaintenanceTasksUnified'))
export const MaintenanceTaskNew = lazy(() => import('../../pages/MaintenanceTaskNew'))
export const Reports = lazy(() => import('../../pages/Reports'))
export const QRSessionsPage = lazy(() => import('../../pages/QRSessionsPage'))
export const MoldLocationMapPage = lazy(() => import('../../pages/MoldLocationMapPage'))
export const ProductionTransferChecklistMaster = lazy(() => import('../../pages/StandardDocumentMaster'))
// 양산처이관 — 금형상세 서브페이지 (maker 작성/제출 → 본사 승인)
export const ProductionTransferChecklist = lazy(() => import('../../pages/ProductionTransferChecklist'))
export const ChecklistMasterConsole = lazy(() => import('../../pages/StandardDocumentMaster'))
export const ChecklistMasterDetail = lazy(() => import('../../pages/StandardDocumentMaster'))
export const DocumentMasterConsole = lazy(() => import('../../pages/StandardDocumentMaster'))
